import { render, staticRenderFns } from "./ExpensesSimpleStaffBox.vue?vue&type=template&id=60a6e33e&"
import script from "./ExpensesSimpleStaffBox.vue?vue&type=script&lang=js&"
export * from "./ExpensesSimpleStaffBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports